import React from "react";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import type { ValuesForTemplate } from "src/lib/locale/types";

const regex = /\{\{([A-Za-z0-9_]+)\}\}/g;

export function formatLocaleString<const T extends string>(
    template: T,
    values: ValuesForTemplate<T>
): string {
    return template.replaceAll(regex, (_substring: string, key: string) => {
        if (Object.prototype.hasOwnProperty.call(values, key)) {
            return values[key as keyof typeof values] ?? "";
        }
        return "";
    });
}

const linkSplit = /\[([^|]+)\|([^\]]+)\]/;

export function formatLocaleStringWithLink(template: string, { hardNav = false, linkClassName }: { hardNav?: boolean; linkClassName?: string; } = {}): React.ReactNode {
    const parts = template.split(linkSplit);
    if (parts.length === 1) return template;

    // split with capturing groups gives: [text, href, label, text, href, label, ...]
    return (
        <>
            {parts.map((part, i) => {
                if (i % 3 === 0) return part;
                if (i % 3 === 1) return null; // href — consumed by the next iteration
                if (hardNav) return <a key={i} className={linkClassName} href={parts[i - 1]}>{part}</a>;
                return <FilmwebLink key={i} className={linkClassName} to={parts[i - 1]}>{part}</FilmwebLink>;
            })}
        </>
    );
}
